import { useCallback, useContext } from 'react';
import { AdyenComponentContainer } from '@/components/expressPayment/AdyenComponentContainer';
import { useAdyenGooglePay } from './useAdyenGooglePay';
import type { ExpressCheckoutComponentProps } from '@/utils/expressPayment';
import { CheckoutContext } from '@/context/CheckoutContext';
import { PaymentMethodEnum } from '@/types/common';
import { trackAndNotifyPaymentClick } from '@/utils/paymentClickEvents';

export const AdyenGooglePay = ({ onReady }: ExpressCheckoutComponentProps) => {
  const context = useContext(CheckoutContext);

  const onClick = useCallback(
    (resolve: () => void, _reject: () => void) => {
      trackAndNotifyPaymentClick(context, PaymentMethodEnum.GOOGLE_PAY);
      resolve();
    },
    [context]
  );

  const { googlePayElement } = useAdyenGooglePay({ onReady, onClick });

  return <AdyenComponentContainer element={googlePayElement} />;
};
